import { render, staticRenderFns } from "./CaixaCard.vue?vue&type=template&id=2920d9ca&scoped=true"
import script from "./CaixaCard.vue?vue&type=script&lang=js"
export * from "./CaixaCard.vue?vue&type=script&lang=js"
import style0 from "./CaixaCard.vue?vue&type=style&index=0&id=2920d9ca&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2920d9ca",
  null
  
)

export default component.exports